import { render, staticRenderFns } from "./ViewBill.vue?vue&type=template&id=3b3fc8a4"
import script from "./ViewBill.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBill.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports